import { ThemeProvider } from '@emotion/react';
import ru from 'date-fns/locale/ru';
import AppRouter from 'modules/navigation/router';
import RouteAdapter from 'modules/navigation/utils/route-adapter';
// global styles start
import 'react-toastify/dist/ReactToastify.css';
import './styles/styles.scss';
import React from 'react';
// global styles end
// React date picker locale setup
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { Slide, ToastContainer } from 'react-toastify';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { history, store } from 'store/store';
import { theme } from 'styles/theme/theme';
import { QueryParamProvider } from 'use-query-params';

registerLocale('ru', ru);
setDefaultLocale('ru');
// React date picker locale setup end

const queryClient = new QueryClient();

const App = React.memo(function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Router history={history}>
          <QueryClientProvider client={queryClient} contextSharing={true}>
            <QueryParamProvider ReactRouterRoute={RouteAdapter}>
              <AppRouter />
            </QueryParamProvider>
          </QueryClientProvider>
        </Router>
      </Provider>
      <ToastContainer autoClose={3000} theme="colored" transition={Slide} />
    </ThemeProvider>
  );
});

export default App;
